


























































































































































































































































import CountTo from '@/components/common/CountTo.vue';
import Video from '@/components/common/Video.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({
  components: {
    Swiper,
    SwiperSlide,
    CountTo,
    Video
  }
})
export default class extends Vue {
  @Prop() public data!: object;
  @Prop() public isActive!: boolean;
  @Prop() public isMobile!: boolean;

  public activeIndex: number = 1; // 衣联网第几页
  public startIndex: number = 0; //第一页当前第一个icon的index
  public endIndex: number = 4; //第一页当前最后一个icon的index
  public screenWidth: number = 0; //屏幕宽度
  public isIE: boolean = false; // 是否是IＥ浏览器
  public videoWidth1: number = 320; //默认视频播放宽度
  public videoWidth2: number = 320; //默认视频播放宽度
  public videoWidth3: number = 600; //默认视频播放宽度
  public videoWidth4: number = 600; //默认视频播放宽度
  public videoWidth5: number = 600; //默认视频播放宽度
  public videoActiveIndex: number = -1; //默认视频播放宽度
  public rec = require('@/assets/image/solution_rec.png');
  public morePoint = require('@/assets/image/solution_morepoint.png');
  public shortPoint = require('@/assets/image/solution_shorepoint.png');
  swiperOptionLeft = {
    //衣联网第一页swiper
    slidesPerView: 5,
    // loopedSlides: 8,
    loop: false,
    spaceBetween: 0,
    autoplay: 3000,
    autoplayDisableOnInteraction: false,
    observer: true,
    pagination: '.swiper-pagination-solution-pc',
    paginationClickable: true,
    onSlideChangeEnd: (swiper) => {
      this.slideLeftChangeEnd(swiper.activeIndex);
    }
  };
  swiperOptionMobileLeft = {
    // 衣联网第一页移动端swiper
    loop: false,
    slidesPerView: 3,
    spaceBetween: 0,
    autoplay: 3000,
    autoplayDisableOnInteraction: false,
    observer: true,
    pagination: '.swiper-pagination-solution-mobile',
    paginationClickable: true
  };
  // 当前页面是否激活
  @Watch('isActive')
  isActiveChange(val) {
    const countTo1 = this.$refs.countTo1 as any,
      countTo2 = this.$refs.countTo2 as any;
    if (val) {
      countTo1 && countTo1.startNumberTransform();
      countTo2 && countTo2.startNumberTransform();
    } else {
      // countTo1 && countTo1.resetPostion();
      // countTo2 && countTo2.resetPostion();
    }
  }

  get pageData() {
    if ((this.data as any).companyProfile1) {
      return this.data;
    }
    return {
      companyProfile1: {
        fileList: []
      },
      companyProfile2: {
        fileList: []
      }
    };
  }
  // 第一页底部展示文字
  get customField() {
    const customField = (this.pageData as any).companyProfile1.customField;
    if (customField) {
      return JSON.parse(customField);
    }
    return { data1: {}, data2: {} };
  }
  // 是否显示第一页
  get isShowLeft() {
    // return (this.pageData as any).companyProfile1.isShow === 1;
    return true;
  }
  // 是否显示第二页
  get isShowRight() {
    return (this.pageData as any).companyProfile2.isShow === 1;
  }
  // 背景图
  get bg() {
    if ((this.pageData as any).cover) {
      return (this.pageData as any).cover;
    }
    return '';
  }
  // 副标题
  get subTitle() {
    if (this.pageData[`companyProfile${this.activeIndex}`]) {
      return this.pageData[`companyProfile${this.activeIndex}`].subtitle;
    }
    return '';
  }
  // 第二页 5部视频
  get firstVideo() {
    if ((this.pageData as any).companyProfile2.fileList.length > 0) {
      return (this.pageData as any).companyProfile2.fileList[0];
    }
    return {};
  }
  get firstVideoHeight() {
    if (this.videoActiveIndex === 1) {
      return '320px';
    } else if (this.videoActiveIndex === 2) {
      return '280px';
    } else {
      return '50%';
    }
  }
  get secondVideoHeight() {
    if (this.videoActiveIndex === 2) {
      return '320px';
    } else if (this.videoActiveIndex === 1) {
      return '280px';
    } else {
      return '47%';
    }
  }
  get thirdVideoWidth() {
    if (this.videoActiveIndex === 3) {
      return '600px';
    } else if (this.videoActiveIndex === 4) {
      return (this.screenWidth - 320 - 320 - 600 - 72) / 2 + 'px';
    } else if (this.videoActiveIndex === 5) {
      return (this.screenWidth - 320 - 320 - 600 - 72) / 2 + 'px';
    } else {
      return (this.screenWidth - 320 - 320 - 72) * 2 / 7 + 'px';
    }
  }
  get forthVideoWidth() {
    if (this.videoActiveIndex === 4) {
      return '600px';
    } else if (this.videoActiveIndex === 3) {
      return (this.screenWidth - 320 - 320 - 600 - 72) / 2 + 'px';
    } else if (this.videoActiveIndex === 5) {
      return (this.screenWidth - 320 - 320 - 600 - 72) / 2 + 'px';
    } else {
      return (this.screenWidth - 320 - 320 - 72) * 3 / 7 + 'px';
    }
  }
  get fifthVideoWidth() {
    if (this.videoActiveIndex === 5) {
      return '600px';
    } else if (this.videoActiveIndex === 4) {
      return (this.screenWidth - 320 - 320 - 600 - 72) / 2 + 'px';
    } else if (this.videoActiveIndex === 3) {
      return (this.screenWidth - 320 - 320 - 600 - 72) / 2 + 'px';
    } else {
      return (this.screenWidth - 320 - 320 - 72) * 2 / 7 + 'px';
    }
  }
  get secondVideo() {
    if ((this.pageData as any).companyProfile2.fileList.length > 1) {
      return (this.pageData as any).companyProfile2.fileList[1];
    }
    return {};
  }
  get thirdVideo() {
    if ((this.pageData as any).companyProfile2.fileList.length > 2) {
      return (this.pageData as any).companyProfile2.fileList[2];
    }
    return {};
  }
  get forthVideo() {
    if ((this.pageData as any).companyProfile2.fileList.length > 3) {
      return (this.pageData as any).companyProfile2.fileList[3];
    }
    return {};
  }
  get fifthVideo() {
    if ((this.pageData as any).companyProfile2.fileList.length > 4) {
      return (this.pageData as any).companyProfile2.fileList[4];
    }
    return {};
  }

  created() {
    this.screenWidth = window.innerWidth;
    this.isIE = this.getIsIE();
  }
  // swiper切换 更新activeIndex
  changeTab(activeIndex: number) {
    this.activeIndex = activeIndex;
  }
  // 第一页swiper 更新activeIndex
  slideLeftChangeEnd(activeIndex: number) {
    this.startIndex = activeIndex;
    this.endIndex = (this.startIndex + 4) % (this.pageData as any).companyProfile1.fileList.length;
  }
  // 是否显示 开始 结尾图片
  isShowStartOrEndImage(index) {
    const prevIndex =
      this.startIndex - 1 < 0 ? (this.pageData as any).companyProfile1.fileList.length - 1 : this.startIndex - 1;
    return this.endIndex !== index && prevIndex !== index;
  }
  // 计算数字滚动组件宽度
  computedWdith(num) {
    if (num) {
      return num.toString().length * 30 + 'px';
    }
    return 0;
  }
  // 是否是IE浏览器
  getIsIE() {
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      return true;
    } else {
      return false;
    }
  }
}
